import { Box } from '@openfin/ui-library';
import React from 'react';
import styled from 'styled-components';

import { TemplateComponentProps } from '..';
import type { ButtonOptions } from '../../../../../client';
import { TemplateMarkdown } from '../../../../../client/templates/templates';
import { StoredNotification } from '../../../../model/StoredNotification';
import { mutable } from '../../../../store/State';
import { ButtonsContainer } from '../../CardButton/CardButtonContainer';
import { NotificationForm } from '../../NotificationForm/NotificationForm';

import { Body } from './Body';

interface Props extends TemplateComponentProps<TemplateMarkdown> {
  clickButtonAction?: (
    notification: StoredNotification<TemplateMarkdown>,
    buttonIndex: number
  ) => void;
  submitForm?: (
    notification: StoredNotification<TemplateMarkdown>,
    form: Record<string, unknown>
  ) => void;
}

export const TemplateMarkdownComponent = ({
  notification,
  clickButtonAction,
  submitForm = () => {},
}: Props): JSX.Element => {
  const handleButtonClick = (event: React.MouseEvent, button: Required<ButtonOptions>) => {
    event.stopPropagation();
    event.preventDefault();
    clickButtonAction?.(notification, button.index);
  };

  return (
    <Container flexDirection="column">
      <Body text={notification.notification.body} />
      {notification.notification.form && (
        <NotificationForm notification={notification} onSubmit={submitForm}>
          <ButtonsContainer
            buttonData={mutable(notification.notification.buttons)}
            onClick={handleButtonClick}
          />
        </NotificationForm>
      )}
    </Container>
  );
};

const Container = styled(Box)`
  width: 100%;
`;
